export default __webpack_public_path__ + "static/media/home-hero-bg-new.609b512e.png";